import React, { useEffect, useState } from 'react';

import Modal from '../shared/modal';
import Button from '../shared/Button';
import Input from '../shared/Input';

const LeadNoteModal = (props) => {
  const {
    open,
    onClose,
    onSubmit,
    loading,
    initialValue = '',
    mode = 'create',
  } = props;

  const [note, setNote] = useState(initialValue || '');

  useEffect(() => {
    if (open) {
      setNote(initialValue || '');
    }
  }, [open, initialValue]);

  const handleSubmit = () => {
    onSubmit(note);
  };

  const isEditMode = mode === 'edit';

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={isEditMode ? 'Edit Note' : 'Add Note'}
      fullWidth
    >
      <div className='lead-note-modal__container'>
        <div className=''>
          <div className='secondary m-b-md'>Lead note</div>
          <Input
            value={note}
            onChange={(e) => setNote(e.target.value)}
            type='textarea'
          />
        </div>

        <div className='form__actions p-t-lg'>
          <Button
            type='submit'
            text={isEditMode ? 'Save Changes' : 'Add Note'}
            onClick={handleSubmit}
            disabled={loading}
            loading={loading}
          />
        </div>
      </div>
    </Modal>
  );
};

export default LeadNoteModal;
